export enum SpecialCompetitions {
  Testmatches = 'testspiele',
  Relegation = 'relegation',
}
